// Flash Cards — R02 font-size option list (template-local, React-free).
// Exactly these four sizes are offered in the Flash Cards Options "Size" selector
// (do NOT change the shared activity-templates/utils/options.js). A saved value
// OUTSIDE this list is preserved: it is added at its sorted position so it still
// displays and persists (compatible display/migration), rather than being reset.

export const FC_FONT_SIZES = [48, 60, 72, 144];

export const fontSizeOptions = (savedValue) => {
  const list = [...FC_FONT_SIZES];
  const n = parseInt(savedValue, 10);
  if (Number.isFinite(n) && n > 0 && !list.includes(n)) {
    list.push(n);
    list.sort((a, b) => a - b);
  }
  return list;
};

export default fontSizeOptions;
